import React from 'react'

const PgVectorIcon: React.FC = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#336791"/>
    <path d="M12 4C9.5 4 7 5.2 7 7V17C7 18.8 9.5 20 12 20C14.5 20 17 18.8 17 17V7C17 5.2 14.5 4 12 4Z" fill="white" fillOpacity="0.15"/>
    <ellipse cx="12" cy="7" rx="5" ry="2" fill="white" fillOpacity="0.9"/>
    <path d="M7 7V11C7 12.8 9.5 14 12 14C14.5 14 17 12.8 17 11V7" stroke="white" strokeOpacity="0.6" strokeWidth="0.5"/>
    <path d="M7 11V15C7 16.8 9.5 18 12 18C14.5 18 17 16.8 17 15V11" stroke="white" strokeOpacity="0.6" strokeWidth="0.5"/>
    <path d="M9 10L11.5 12.5L15 8.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

export default PgVectorIcon
